import {CreativeTemplate, CreativeTemplateFeature} from '../creativeTemplates.types';
import {TemplateEssentials} from '../../creatives/creatives.types';

function isLocationSupportedTemplate(template: CreativeTemplate | TemplateEssentials): boolean {
  return template?.features.includes(CreativeTemplateFeature.Location);
}

export default isLocationSupportedTemplate;
